import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { RatioDirective } from '../../directives/ratio.directive';

@Component({
  selector: 'app-article-card-loading',
  templateUrl: './article-card-loading.component.html',
  styleUrls: ['./article-card-loading.component.scss'],
  imports: [SkeletonModule, RatioDirective],
})
export class ArticleCardLoadingComponent {}
